/**
 * Admin screens and who may use them. Administrators use all of them; staff use the ones an administrator
 * gave them (user.permissions); admin-only screens are never given to staff. The API enforces the same rules.
 */
export const adminSections = [
  { path: '/admin/bookings', label: 'Bookings', permission: 'Bookings' },
  { path: '/admin/amendments', label: 'Amendments', permission: 'Amendments' },
  { path: '/admin/reports', label: 'Reports', permission: 'Reports' },
  { path: '/admin/packages', label: 'Packages', permission: 'Packages' },
  { path: '/admin/enquiries', label: 'Enquiries', permission: 'Enquiries' },
  { path: '/admin/promo-codes', label: 'Promo codes', permission: 'PromoCodes' },
  { path: '/admin/fees', label: 'Convenience fees', permission: 'Fees' },
  { path: '/admin/currencies', label: 'Currencies', permission: 'Currencies' },
  { path: '/admin/supplier-settings', label: 'Supplier settings', adminOnly: true },
  { path: '/admin/users', label: 'Users & staff', adminOnly: true },
];

export const isAdminUser = (user) => Boolean(user?.roles?.includes('Admin'));
export const isStaffUser = (user) => Boolean(user?.roles?.includes('Staff'));

/** True when the account may use admin screens at all. */
export const hasBackOffice = (user) => isAdminUser(user) || (isStaffUser(user) && (user.permissions || []).length > 0);

export function canUse(user, section) {
  if (!section || !user) return false;
  if (isAdminUser(user)) return true;
  if (section.adminOnly || !isStaffUser(user)) return false;
  return (user.permissions || []).includes(section.permission);
}

export const can = (user, permission) => isAdminUser(user) || (isStaffUser(user) && (user.permissions || []).includes(permission));

export const sectionFor = (pathname) => adminSections.find((s) => pathname === s.path || pathname.startsWith(`${s.path}/`));

export const visibleSections = (user) => adminSections.filter((s) => canUse(user, s));

/** Where the header's Admin link goes: the first screen the account can use. */
export const firstAdminPath = (user) => visibleSections(user)[0]?.path || '/';
